import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "axios";
import { API_URL } from "../../config";
import moment from "moment";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import Loader from "../Loader/Loader";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function PlayerBanned() {
  const { accessObject } = useAppContext();

  const [showPrePage, setShowPrePage] = React.useState(10);
  const [loader, setLoader] = React.useState(true);
  const [filteredData, setFilteredData] = React.useState([]);
  // const [changeDeviceType, setChangeDeviceType] = React.useState();
  const [searchEmail, setSearchEmail] = React.useState();
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState("");
  const [testPage, setTestPage] = React.useState(false);

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  React.useEffect(() => {
    getPlayerList();
  }, [pageNumber, recordLength, searchEmail, testPage]);

  const getPlayerList = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-all-ios-player-details`, {
        pageNumber: pageNumber,
        recordLength: recordLength,
        search: searchEmail,
      })
      .then((response) => {
        setLoader(false);

        setFilteredData(response.data.data.playerData);
        setTotalLength(response.data.data?.totalLength[0]?.totalCount);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  return (
    <>
      <div className="content p-3">
        <div class="card ">
          <div class="pl-4 pr-4 pt-4">
            <div class="pl-4 pr-4 pt-4 d-flex flex-column flex-md-row justify-content-between align-items-lg-center align-items-start">
              <h3 class="card-title">
                <b>Banned Player List</b>
              </h3>
              <div>
                <input
                  class="input-simple"
                  type="text"
                  placeholder="Email And Name ..."
                  value={searchEmail}
                  onChange={(e) => {
                    setPageNumber(1);
                    setRecordLength(10);
                    setSearchEmail(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div class="card-body" style={{ overflow: "scroll" }}>
            <table id="" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>SrNo</th>
                  <th style={{ textAlign: "center" }}>Date</th>
                  <th style={{ textAlign: "center" }}>Id</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Email</th>
                  <th style={{ textAlign: "center" }}>Balance</th>
                  <th style={{ textAlign: "center" }}>Device Type</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                </tr>
              </thead>
              {accessObject?.getPlayerList == true ? (
                <>
                  <tbody>
                    {!loader ? (
                      <>
                        {filteredData.length > 0 ? (
                          <>
                            {filteredData?.map((item, index) => {
                              return (
                                <>
                                  <tr key={index}>
                                    <td>
                                      {pageNumber === 1
                                        ? index + 1
                                        : index +
                                          1 +
                                          pageNumber * recordLength -
                                          recordLength}
                                    </td>
                                    <td>
                                      {moment(item.createdAt).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </td>
                                    <td>{item.playerId}</td>
                                    <td>{item.name || "-"}</td>
                                    <td>{item.email || "-"}</td>
                                    <td>
                                      {item.depositeBalance +
                                        item.withdrawBalance +
                                        item.bonusBalance}
                                      {/* {Math.round(item.balance * 100) /
                                              100} */}
                                    </td>
                                    <td>
                                      {item.deviceType === 0
                                        ? "Android"
                                        : "IOS"}
                                    </td>
                                    <td>
                                      {item.playerStatus === 0
                                        ? "Active"
                                        : "Banned"}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <tr>
                              <td colSpan={10}>
                                <h5 className="text-center">
                                  No Data Available
                                </h5>
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </tbody>
                </>
              ) : (
                <>
                  <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
                    <td colSpan={8}>
                      <h5 className="text-center">Access Denied</h5>
                    </td>
                  </tr>
                </>
              )}
            </table>
            {accessObject?.getPlayerList == true && (
              <div className="mt-4">{loader && <Loader />}</div>
            )}
          </div>
          {accessObject?.getPlayerList == true && filteredData.length != 0 && (
            <div>
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={filteredData.length}
                paginationTypeApi={true}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                recordLength={recordLength}
                setRecordLength={setRecordLength}
                totalLength={totalLength}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
